import { Client } from "./_clientService";

export async function createPlayStyle(pack: any) {
  try {
    const response = await new Client({
      path: `/play-styles/create`,
      payload: pack,
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPlayStyles() {
  try {
    const response = await new Client({
      path: `/play-styles/list`,
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePlayStyle(packDetails: any) {
  try {
    const response = await new Client({
      path: `/play-styles/update`,
      payload: packDetails,
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPlayStyleInfo(playStyleId: any) {
  try {
    const response = await new Client({
      path: `/play-styles/info`,
      payload: { playStyleId },
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}
